export const AUTH_PROFILE_QUERY_KEY = ["authProfile"];

// The `/profile/` unread counters are cached server-side for ~10 minutes,
// so invalidating and refetching right after a mark-as-read action would
// just replay the stale count. Patch the cached value locally instead and
// let the next scheduled refetch reconcile with the server.
export const patchProfileCounts = (queryClient, updater) => {
  queryClient.setQueryData(AUTH_PROFILE_QUERY_KEY, (old) => {
    if (!old?.data) return old;
    return { ...old, data: { ...old.data, ...updater(old.data) } };
  });
};
